<template>
	<div class="navbar-container">
		<b-navbar type="dark" variant="dark" class="main-navbar" :class="{'mobile-navbar': isMobile}">
			<b-navbar-brand to="/">
				<img width="32" height="32" src="~assets/img/logo.png" alt="Home">
			</b-navbar-brand>
			<b-navbar-nav>
				<slot></slot>
			</b-navbar-nav>
			<b-navbar-nav class="ml-auto">
				<slot name="right"></slot>
			</b-navbar-nav>
		</b-navbar>
		
		<main class="main-content">
			<router-view></router-view>
			<div v-if="isMobile" class="mobile-nav-spacer"></div>
		</main>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isMobile: window.innerWidth <= 991
			}
		},
		mounted() {
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			handleResize() {
				this.isMobile = window.innerWidth <= 991;
			},
			getClasses: function() {
				return {
					active: this.isActive
				}
			}
		},
		computed: {
			isActive() {
				return this.$route.path.indexOf(this.path) != -1
			}
		}
	}
</script>

<style>
.navbar-container {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.main-content {
	flex: 1;
	width: 100%;
}

/* PC 端样式 */
@media (min-width: 992px) {
	.main-navbar {
		position: sticky;
		top: 0;
		z-index: 1030;
	}
}

/* 移动端样式 */
@media (max-width: 991px) {
	.mobile-navbar {
		position: fixed !important;
		bottom: 0 !important;
		left: 0 !important;
		right: 0 !important;
		top: auto !important;
		width: 100% !important;
		z-index: 10000 !important;
		margin: 0 !important;
		border: none !important;
		border-top: 1px solid rgba(255,255,255,0.1) !important;
		transform: translateZ(0);
		-webkit-transform: translateZ(0);
		background-color: #1a1a1a !important;
		padding-bottom: env(safe-area-inset-bottom) !important;
		backface-visibility: hidden;
	}

    /* 优化移动端菜单项显示 */
    .mobile-navbar .navbar-nav {
        flex-direction: row !important;
        justify-content: space-around;
        width: 100%;
    }

    .mobile-navbar .nav-link {
        padding: 0.5rem 0.2rem !important;
        font-size: 1.05rem !important;
        white-space: nowrap;
    }
	
	.mobile-nav-spacer {
		display: block;
		height: 60px;
		height: calc(60px + env(safe-area-inset-bottom));
		pointer-events: none;
	}
}

/* 解决有些容器 transform 破坏 fixed 的兜底 */
body {
	position: relative;
}
</style>
